import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Space,
  Card,
  Flex,
  Dropdown,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { getOrderItemDetails } from '../../../network/purchaseOrder';
import { useMutation, useQuery } from '@tanstack/react-query';
import { MdEdit } from 'react-icons/md';
import { BiSolidShow } from 'react-icons/bi';
import { ModalAppItemDetails } from '../ModalApp/ModalApp';
import { getItemDetails } from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApiIsStock } from '../../../network/appointment';
import { getSearchApiSearchText } from '../../../network/itemList';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
const ItemMaterialList = ({
  type,
  warehouse,
  setDataSource,
  dataSource,
  selectedIndex,
  setSelectedIndex,
  t,
  form,
  priceList = '',
}) => {
  console.log('selectedIndex', selectedIndex);

  const [selectData, setSelectData] = useState({});
  const [searchTextItems, setSearchTextItems] = useState('');
  const [open, setOpen] = useState(false);
  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const [searchTextAccount, setSearchTextAccount] = useState('');
  console.log(dataSource, 'dataSource');
  const [count, setCount] = useState(0);
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch, searchTextCostCenter],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Cost Center',
        searchTxt: searchTextCostCenter,
      }),
    keepPreviousData: true,
  });
  const { data: accounts } = useQuery({
    queryKey: [queryKeys.getSearchAccount, searchTextAccount],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Account',
        searchTxt: searchTextAccount,
      }),
    keepPreviousData: true,
  });
  const { mutate: onGetItemDetails, data: itemDetails } = useMutation({
    mutationFn: (itemName) => getItemDetails('Material Request', itemName),
    onSuccess: (itemDetails) => {
      console.log(itemDetails, 'itemDetails');
      const newDataSource = [...dataSource];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        ...itemDetails?.message,
        warehouse: form.getFieldValue('set_warehouse'),
        // item_code: itemDetails?.message?.item_name,
      };
      setDataSource(newDataSource);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTextItems],
    queryFn: () =>
      getSearchApiIsStock({ type: 'Item', text: searchTextItems, stock: 1 }),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: <BiSolidShow />,
      onClick: () => {
        handleDetails(record.key);
        setSelectedIndex(record.key);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.confirmDelete}
          onConfirm={() => handleDelete(record.key)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.items,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          placeholder={t.items}
          value={
            record?.item_code
              ? {
                  key: record.item_code,
                  label: itemsList?.message?.find(
                    (i) => i.value === record.item_code
                  )?.description,
                }
              : undefined
          }
          labelInValue
          style={{ width: '200px' }}
          showSearch
          // optionFilterProp="children"
          // filterOption={(input, option) =>
          //   (option?.label ?? '')
          //     .toLocaleLowerCase()
          //     .includes(input.toLocaleLowerCase())
          // }
          filterOption={false}
          onSearch={(value) => setSearchTextItems(value)}
          // filterSort={(optionA, optionB) =>
          //   (optionA?.label ?? '')
          //     .toLowerCase()
          //     .localeCompare(
          //       (optionB?.label ?? '').toLowerCase()
          //     )
          // }
          popupMatchSelectWidth={false}
          onChange={(value) => {
            setSelectedIndex(index);
            onGetItemDetails(value.key);
          }}
          // options={itemsList?.message?.items?.map((item) => ({
          //   value: item?.name,
          //   label: item?.item_name,
          // }))}
          // options={itemsList?.message?.map((item) => ({
          //   value: item?.value,
          //   label: item?.value,
          //   option: item,
          // }))}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option
              key={item?.value}
              value={item?.value}
              label={item?.description}
            >
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      // hidden: type === 'Purchase Order' ? false : true,
      title: t.scheduleDate,
      dataIndex: 'schedule_date',
      render: (text, record, index) => (
        <DatePicker
          onChange={(date, dateString) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              schedule_date: dateString,
            };
            setDataSource(newDataSource);
          }}
          format="YYYY-MM-DD"
          placeholder={t.scheduleDate}
          style={{ width: '100%', marginBottom: '0px' }}
          value={dayjs(record.schedule_date)}
        />
      ),
    },
    {
      // hidden: type === 'Purchase Order' ? false : true,
      title: t.warehouse,
      dataIndex: 'warehouse',
      render: (text, record, index) => (
        <Select
          placeholder={t.setWarehouse}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          value={record?.warehouse}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              warehouse: value,
            };
            setDataSource(newDataSource);
          }}
          options={warehouse?.data?.map((item) => ({
            value: item?.name,
            label: item?.warehouse_name,
          }))}
        />
      ),
    },
    {
      title: t.quantity,
      dataIndex: 'qty',
      render: (text, record, index) => (
        <Input
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
              amount: e.target.value * record.rate,
            };
            setDataSource(newDataSource);
          }}
          placeholder={t.quantity}
          type="number"
          value={record.qty}
          min={0}
        />
      ),
    },
    {
      title: t.expenseAccount,
      dataIndex: 'expense_account',
      render: (text, record, index) => (
        <Select
          placeholder={t.expenseAccount}
          showSearch
          popupMatchSelectWidth={false}
          optionFilterProp="children"
          value={record.expense_account}
          onSearch={(value) => setSearchTextAccount(value)}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              expense_account: value,
            };
            setDataSource(newDataSource);
          }}
          filterOption={false}
          options={accounts?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
        />
      ),
    },
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
      render: (text, record, index) => (
        <Select
          showSearch
          allowClear
          filterOption={false}
          onSearch={(value) => {
            setSearchTextCostCenter(value);
          }}
          value={record.cost_center}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              cost_center: value,
            };
            setDataSource(newDataSource);
          }}
          placeholder={t.costCenter}
          options={costCenters?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
        />
      ),
    },
    // {
    //   title: t.Rate,
    //   dataIndex: 'rate',
    // },
    // {
    //   title: t.amount,
    //   dataIndex: 'amount',
    // },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Flex gap={10}>
          <Button
            type="primary"
            // icon={<MdEdit />}
            icon={<BiSolidShow />}
            size="small"
            onClick={() => {
              handleDetails(record.key);
              setSelectedIndex(index);
            }}
          />
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Flex>
        // <Dropdown
        //   menu={{ items: items(record) }}
        //   overlayClassName="custom-dropdown"
        //   trigger={['click']}
        // >
        //   <Button
        //     type="text"
        //     icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
        //   />
        // </Dropdown>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      warehouse: form.getFieldValue('set_warehouse'),
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  const handleDetails = (key) => {
    const row = dataSource?.find((item) => item?.key === key);
    if (row) {
      setSelectData({
        ...row,
        schedule_date: dayjs(row.schedule_date).format('YYYY-MM-DD'),
      });
      setDataSource(
        dataSource.map((item) => ({
          ...item,
          schedule_date: dayjs(item.schedule_date).format('YYYY-MM-DD'),
        }))
      );
      setOpen(true);
      console.log('Row details:', row);
    }
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      <ModalAppItemDetails
        setDataSource={setDataSource}
        dataSource={dataSource}
        selectedIndex={selectedIndex}
        type="Material Request"
        open={open}
        setOpen={setOpen}
        t={t}
        selectData={selectData}
      />
    </Card>
  );
};

export default ItemMaterialList;
